import { fetcher } from '@commenda/utils';

export interface LinkAdminHubSpotCompanyParams {
  companyId: number;
  hubspotCompanyId: string;
}

export function linkAdminHubSpotCompany({
  companyId,
  hubspotCompanyId,
}: LinkAdminHubSpotCompanyParams) {
  return fetcher(
    `admin/companies/${companyId}/external-connections/hubspot/link`,
    {
      method: 'POST',
      body: { hubspotCompanyId },
    }
  );
}
